export default [

     {
          path: '/escalation',
          name: 'Escalation',
          component: () => import("@/views/Page/Escalation/Escalation.vue"),
           meta: {
               title: 'Escalation',
          },
     },

     {
          path: '/escalation-details/:id',
          name: 'EscalationDetails',
          component: () => import("@/views/Page/Escalation/EscalationDetails.vue"),
           meta: {
               title: 'EscalationDetails',
          },
     }


];